// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3jwi_","errors":"Errors_errors__1DD8B"};